import React from 'react'
import Particles from "react-tsparticles";
import { Container,Row,Col } from 'reactstrap';
import Header from '../Components/Navbar';
import Event from '../Components/Event';
import GlitchClip from 'react-glitch-effect/core/GlitchClip';
import tklogo from "../assets/tklogo.png"

const OnlineEvents = ()=> {

    return (
        <div className="online">
             <Particles
                id="tsparticles"
                options={{
                background: {
                    color: {
                    value: "#000",
                    },
                },
                fpsLimit: 60,
                
                particles: {
                    color: {
                    value: "#ffff",
                    },
                    links: {
                    color: "#ffff",
                    distance: 100,
                    enable: true,
                    opacity: 0.5,
                    width: 1,
                    },
                    collisions: {
                    enable: true,
                    },
                    move: {
                    direction: "none",
                    enable: true,
                    outMode: "bounce",
                    random: false,
                    speed: 2,
                    straight: false,
                    },
                    number: {
                    density: {
                        enable: true,
                        value_area: 1000,
                    },
                    value: 50,
                    },
                    opacity: {
                    value: 0.5,
                    },
                    shape: {
                    type: "circle",
                    },
                    size: {
                    random: true,
                    value: 3,
                    },
                },
                detectRetina: true,
                }}
            />
            <Header img={tklogo}></Header>
            <Container>
                <div className="online">
                    <div className="gbox">
                    <GlitchClip>
                        <h5 className="text-white title py-3">Online Events_</h5>
                    </GlitchClip>
                    </div>
                    <Row>
                    <Col md="3" xs="6" lg="2" className="my-2">
                        <Event
                            event="Graphite-ty"
                            rules={"> Only one submission per person is allowed \n > Photographs, wires, and other 3D objects are not acceptable \n > The work will be judged based on creativity and neatness, incase of tie likes will be considered \n > The entries shouldn’t have any watermark \n > The entry should be uploaded during registration \n >  Identification of plagiarism will lead to disqualification \n > The judge's decision will be final"}
                            text={"Sketch the monochrome behind the chaos and express the inexplicable, your way. Bring out the world you see through the tip of your pencil. "}
                            img= {require("../assets/online/graphity.png")}
                            name="Sriram"
                            no="9677265902"
                            name1="Sivadarshini"
                            no1="6379827686"
                            link="https://forms.gle/ybhnwrMcXcsjPgW76"
                            >
                        </Event>
                    </Col>
                    <Col md="3" xs="6" lg="2" className="my-2">
                        <Event 
                            event="Tiny Tales"
                            rules={"> Open theme \n > It must be written in English only \n > Each entry must contain at most 14 lines/sonnet \n > Only original poems are permitted for participation \n > The work will be judged based on creativity and neatness, incase of tie likes will be considered \n > Plagiarism will be viewed seriously and may result in disqualification if found \n > Entries must be uploaded as document (.txt/.doc) format while registration"}
                            text={"Take us to your world, make us live in it through your fables as the power of your pen is not in the colour of ink it spills; but the power of the word it spells."}
                            img= {require("../assets/online/tinytales.png")}
                            name="Janani"
                            no="9840603544"
                            name1="TamilSelvan"
                            no1="7708390902"
                            link="https://forms.gle/itfGNUCwwWDemWqi7"
                            >
                        </Event>
                    </Col>
                    <Col md="3" xs="6" lg="2" className="my-2">
                        <Event 
                            event="Snap Shot"
                            rules={"> Basic editing, including color enhancement, and cropping of the Photo is acceptable \n > The work will be judged based on creativity, incase of tie likes will be considered \n > The entries shouldn’t have any watermark \n > The entries should be submitted during registration \n > Identification of plagiarism will lead to disqualification \n > The judge's decision will be final"}
                            text={"A photo is a moment frozen forever in time. Show the life you've lived through the lens and the moments you've preserved through your clicks."}
                            img= {require("../assets/online/snapshot.png")}
                            name="Sriram"
                            no="9677265902"
                            name1="ShyamSundar"
                            no1="9629105054"
                            link="https://forms.gle/kPM7uBczKS3UVjhx7"
                            >
                        </Event>              
                    </Col>
                    <Col md="3" xs="6" lg="2" className="my-2">
                        <Event 
                            event="Rhapsody"
                            rules={"> Performance can be of any language \n > Karaoke is not allowed. Only vocal tracks are allowed \n > The maximum duration of the track is 30 seconds \n > Jury decision will be based on your singing skills \n > Submit your audio file in the given registration form \n > Judges decision will be final \n > The entries should be uploaded during registration"}
                            text={"Music is what feelings sound like. Escape from reality to fill the void and let the tunes bring out the emotions in you."}
                            img= {require("../assets/online/rhapsody.png")}
                            name="Janani"
                            no="9840603544"
                            name1="Saran"
                            no1="8925236404"
                            link="https://forms.gle/mou5drHcd8Gne4jYA"
                            >
                        </Event>
                    </Col>
                    <Col md="3" xs="6" lg="2" className="my-2">
                        <Event 
                            event="PosterCon"
                            rules={"> Only one submission per person is allowed \n > Posters can be made using any mobile app or design software like Adobe Photoshop, Illustrator, and Gimp, etc. \n > The work will be judged based on creativity, incase of tie likes will be considered \n > The entries shouldn’t have any watermark \n > Identification of plagiarism will lead to disqualification \n > Judges decision will be final \n > Contents triggering hatred on caste, politics and religion will not be encouraged"}
                            text={"Let the artist in you run wild. Portray your visions, all while flaunting your edit aesthetics. Create, edit, post,  right here at PosterCon."}
                            img= {require("../assets/online/postercon.png")}
                            name="Loganand"
                            no="8838796372"
                            name1="Muthulakshmi"
                            no1="8344454083"
                            link="https://forms.gle/QQoHcCdE2niACzmp9"
                            >
                        </Event>
                    </Col>
                    <Col md="3" xs="6" lg="2" className="my-2">
                        <Event 
                            event="Videonix"
                            rules={"> Includes Timelapse, Hyperlapse, Stop-motion, Creative B-rolls, Slow-mo etc. \n > Only 1 entry from an individual participant is allowed \n > Must shoot the video from indoors (Max. 1 minute) \n > The work will be judged based on creativity, incase of tie likes will be considered \n > The entries shouldn’t have any watermark \n > Judges decision will be final \n > Offensive,explicit and triggering content will not be encouraged"}
                            text={"Let’s get those edits rolling! Capture, cut, slide and swipe, brew the best footage and bring out the creative cinematographer in you."}
                            img= {require("../assets/online/videonix.png")}
                            name="Loganand"
                            no="8838796372"
                            name1="Janeshwar"
                            no1="9952147275"
                            link="https://forms.gle/J546M2tqVLparFwP8"
                            >
                        </Event>
                    </Col>
                    <Col md="3" xs="6" lg="2" className="my-2 offset-lg-2">
                        <Event 
                            event="Scribbles"
                            rules={"> Doodles should be free from the content \n > The doodle submitted should be authentic & unpublished \n > The work will be judged based on creativity and neatness, incase of tie likes will be considered \n > The entries shouldn’t have any watermark \n > Identification of plagiarism will lead to disqualification \n > Judges decision will be final"}
                            text={"The deeper you look the more you see. Doodle your imagination into wild randomness for its time to bring your last page art to the front page now."}
                            img= {require("../assets/online/doodles.png")}
                            name="Sriram"
                            no="9677265902"
                            name1="Srihareesh"
                            no1="8838048485"
                            link="https://forms.gle/qDaKRWNeVqUqSRZV7"
                            >
                        </Event>
                    </Col>
                    <Col md="3" xs="6" lg="2" className="my-2">
                        <Event 
                            event="Dance Away"
                            rules={"> 1 minute choreography of your desired song \n > Must be one shot video with no editing \n > The video should be shot in a presentable background with  considerable quality \n > Jury decision will be based on your dancing style \n > Submit your video file in the given registration form while registration \n > Judges decision will be final"}
                            text={"A time where the art of your moments define everything, from peace to thrill, solace to excitement, happiness or sadness. Let go of your madness for today, let your dance speak for you."}
                            img= {require("../assets/online/swayit.png")}
                            name="Kavya"
                            no="6374253694"
                            name1="Akshaya"
                            no1="6385603425"
                            link="https://forms.gle/aGSAPUXeBVosGqRb6"
                            >
                        </Event>
                    </Col>
                    <Col md="3" xs="6" lg="2" className="my-2">
                        <Event 
                            event="Artistik"
                            rules={"> Craftwork can be made out of any materials \n > The work will be judged based on creativity and neatness, incase of tie likes will be considered \n > Usage of paints are allowed \n > The presentation of readymade crafts will lead to disqualification \n > The entries shouldn’t have any watermark \n > Identification of plagiarism will lead to disqualification \n > The judge's decision will be final \n > Entry can be of photo and video format"}
                            text={"Craft is the visible edge of art. Create your vision of uniqueness and let the world witness the beauty in making."}
                            img= {require("../assets/online/artistik.png")}
                            name="Sriram"
                            no="9677265902"
                            name1="SivaPoorani"
                            no1="8925641134"
                            link="https://forms.gle/NkdQHc5rTAWoo7rX9"
                            >
                        </Event>
                    </Col>
                    <Col md="3" xs="6" lg="2" className="my-2">
                        <Event 
                            event="நானும் பாரதி"
                            rules={"> Open theme \n > It must be written in Tamil only \n > Each entry must contain at most 14 lines \n > Only original poems are permitted for participation \n > The work will be judged based on creativity and neatness, incase of tie likes will be considered \n > Plagiarism will be viewed seriously and may result in disqualification if found \n > Entries must be uploaded as document (.txt/.doc) format while registration"}
                            // text={""}
                            img= {require("../assets/online/tamillit.png")}
                            name="Janani"
                            no="9840603544"
                            name1="TamilSelvan"
                            no1="7708390902"
                            link="https://forms.gle/VRNzrjw19Gdj4B2S6"
                            >
                        </Event>
                    </Col>
                    </Row>
                </div>
            </Container>
        </div>
    )
}
export default OnlineEvents;